export default {
  menu: (state, getters) => {
    return state.menu;
  },
  tree: (state, getters) => {
    return state.tree;
  },
  parent: (state, getters) => {
    return state.parent;
  },
};
